import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "spectrum-css"
    }}>{`Spectrum CSS`}</h1>
    <p><a parentName="p" {...{
        "href": "https://opensource.adobe.com/spectrum-css/"
      }}>{`Spectrum CSS`}</a>{` is Adobe's open-source implementation of Adobe's design system, used across multiple applications.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you want to dive right in to using Spectrum CSS, head over to the `}<a parentName="p" {...{
          "href": "https://github.com/adobe/spectrum-css/blob/main/README.md"
        }}>{`GitHub site`}</a>{` and read the installation instructions.`}</p>
    </blockquote>
    <p>{`Your plugin should use Spectrum-based controls wherever possible in its UI, both for consistency and because, over time, Adobe applications' own controls will migrate to using Spectrum CSS.`}</p>
    <p>{`Additionally, with Spectrum controls your plugin gets theme awareness essentially for free. So when the user changes from light to dark, you don't have to wire up all those appearance changes yourself.`}</p>
    <p>{`As used in UXP, Spectrum CSS provides a library of UI components that enable a consistent look and feel, both within an application and for cross-platform and cross-application plugins.`}</p>
    <p>{`Spectrum CSS is "pure" CSS; no JavaScript or other code is required to use it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      